import { ProFormGroup } from '@ant-design/pro-components'
import { AcademicTitleEnum, SalutationEnum } from '@app/icare/db/schema/common'
import { Trans } from '@lingui/react/macro'
import { useFieldContext, useFormContext } from '@pkg/form/createAppFormHook'
import { joinNames } from '@pkg/form/utils/form.utils'

export interface PersonalGroup {
  firstName?: string | null
  lastName?: string | null
  salutation?: string | null
  honorificPrefix?: string | null
}

export type PersonalGroupFieldProps = {
  className?: string
}

export function PersonalGroupField(props: PersonalGroupFieldProps) {
  const { className } = props
  const field = useFieldContext<PersonalGroup>()
  const form = useFormContext()

  return (
    <ProFormGroup title={false} rowProps={{ gutter: [16, 0] }} className={className}>
      <form.AppField name={joinNames(field, 'salutation')}>
        {field => (
          <field.Select
            label={<Trans>Anrede</Trans>}
            colProps={{ md: 4, xs: 24 }}
            request={async () => SalutationEnum.$.options}
          />
        )}
      </form.AppField>
      <form.AppField name={joinNames(field, 'honorificPrefix')}>
        {field => (
          <field.Select
            label={<Trans>Titel</Trans>}
            colProps={{ md: 4, xs: 24 }}
            request={async () => AcademicTitleEnum.$.options}
          />
        )}
      </form.AppField>
      <form.AppField name={joinNames(field, 'firstName')}>
        {field => <field.Text label={<Trans>Vorname</Trans>} colProps={{ md: 8, xs: 24 }} />}
      </form.AppField>
      <form.AppField name={joinNames(field, 'lastName')}>
        {field => <field.Text label={<Trans>Nachname</Trans>} colProps={{ md: 8, xs: 24 }} />}
      </form.AppField>
    </ProFormGroup>
  )
}
